import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatQuoteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_quote"}/>
}
